"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Setting;
(function (Setting) {
  Setting["disallowUnmute"] = "DisallowUnmute";
  Setting["muteOnEntry"] = "MuteOnEntry";
})(Setting || (Setting = {}));
var _default = Setting;
exports.default = _default;
//# sourceMappingURL=enums.js.map
